<template>
  <v-row>
    <v-col cols="12" class="py-0 my-0">
      <div class="font-weight-medium text-h6">Special Requests</div>
    </v-col>
    <v-col cols="12">
      <v-card flat class="rounded-xl secondary--border overflow-y-auto">
        <v-data-table
          :headers="headers"
          :items="specialRequests"
          hide-default-footer
          height="320"
          :loading="loading"
        >
          <template v-slot:header.date="{ header }">
            <div
              class="py-6 px-5 text-body-1 font-weight-bold primary--text d-flex align-center"
            >
              <span class="font-weight-bold">{{ header.text }}</span>
            </div>
          </template>
          <template v-slot:header.action="{ header }">
            <div class="py-6 text-body-1 font-weight-bold primary--text">
              {{ header.text }}
            </div>
          </template>
          <template v-slot:header.time="{ header }">
            <div class="py-6 text-body-1 font-weight-bold primary--text">
              {{ header.text }}
            </div>
          </template>
          <template v-slot:header.type="{ header }">
            <div class="py-6 text-body-1 font-weight-bold primary--text">
              {{ header.text }}
            </div>
          </template>
          <template v-slot:header.amount_paid="{ header }">
            <div class="py-6 text-body-1 font-weight-bold primary--text">
              {{ header.text }}
            </div>
          </template>
          <template v-slot:item="props">
            <tr>
              <td class="text-body-1 font-weight-medium py-6">
                {{ props.item.requesttype ? props.item.requesttype.name : 'Special Request' }}
              </td>
              <td class="text-body-1">
                <v-chip
                  x-small class=" text-capitalize text-caption"
                  :color="
                    props.item.status == 'paid'
                      ? 'success'
                      : props.item.status == 'partpaid'
                      ? 'secondary'
                      : 'error'
                  "
                >
                  {{ props.item.status }}
                </v-chip>
              </td>
              <td class="text-body-1">
                {{
                  props.item.amount
                }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
// import { UserService } from "@/services/index.js";
import { formatDate, formatMoney } from "@/utils/helpers";

export default {
    props: {
        specialRequests: {
            type: Array
        }
    },
  data() {
    return {
      formatDate,
      formatMoney,
      loading: false,
      headers: [
        {
          text: "Title",
          align: "start",
          sortable: false,
          value: "name",
        },
        // { text: "Date", value: "action", sortable: false },
        { text: "Status", value: "time", sortable: false },
        // { text: "Landbank", value: "type", sortable: false },
        { text: "Amount", value: "amount_paid", sortable: false },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.theme--light.v-data-table tbody tr:nth-of-type(odd) {
  background-color: #fff9f2;
  border: 5px solid blue !important;
  border-top: none !important;
  border-bottom: none !important;
}
.theme--dark.v-data-table tbody tr:nth-of-type(odd) {
  background-color: #fff9f2;
  border: 5px solid blue !important;
  border-bottom: none !important;
  border-top: none !important;
}
</style>
